import ChatBot from "../ChatBot/ChatBot";
import MainNavigation from "../nav_footer/MainNavigation";
import Iconnav from "./Iconnav";
const Form = () => {
  return (
    <>
      <MainNavigation />
      <Iconnav />
      <ChatBot/>
    </>
  );
};
export default Form;
